// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @charset "UTF-8";
.selectNative,
.selectCustom {
  position: relative;
  width: 22rem;
  height: 4rem;
}

.selectCustom {
  position: absolute;
  top: 0;
  left: 0;
  display: none;
}

@media (hover: hover) {
  .selectCustom {
    display: block;
  }

  .selectNative:focus + .selectCustom {
    display: none;
  }
}

.selectNative:focus,
.selectCustom.isActive .selectCustom-trigger {
  outline: none;
  box-shadow: white 0 0 0 0.2rem, #ff821f 0 0 0 0.4rem;
}

.select {
  position: relative;
}

.selectLabel {
  display: block;
  font-weight: bold;
  margin-bottom: 0.4rem;
}

.selectWrapper {
  position: relative;
}

.selectNative,
.selectCustom-trigger {
  font-size: 1.6rem;
  background-color: #fff;
  border: 1px solid #6f6f6f;
  border-radius: 0.4rem;
}

.selectNative {
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 0.8rem;
  padding: 0rem 0.8rem;
}

.selectCustom-trigger {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 0.8rem 0.8rem;
  cursor: pointer;
}

.selectCustom-trigger::after {
  content: "▾";
  position: absolute;
  top: 0;
  line-height: 3.8rem;
  right: 0.8rem;
}

.selectCustom-trigger:hover {
  border-color: #8c00ff;
}

.selectCustom-options {
  position: absolute;
  top: calc(3.8rem + 0.8rem);
  left: 0;
  width: 100%;
  border: 1px solid #6f6f6f;
  border-radius: 0.4rem;
  background-color: #fff;
  box-shadow: 0 0 4px #e9e1f8;
  z-index: 1;
  padding: 0.8rem 0;
  display: none;
}

.selectCustom.isActive .selectCustom-options {
  display: block;
}

.selectCustom-option {
  position: relative;
  padding: 0.8rem;
  padding-left: 2.5rem;
}

.selectCustom-option.isHover,
.selectCustom-option:hover {
  background-color: #865bd7;
  color: white;
  cursor: default;
}

.selectCustom-option:not(:last-of-type)::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  border-bottom: 1px solid #d3d3d3;
}

.selectCustom-option.isActive::before {
  content: "✓";
  position: absolute;
  left: 0.8rem;
} */

[class*="-indicatorContainer"]{
  padding: 5px !important;
}

.fast-option {
  font-size: 12px;
}

.fast-option-focused{
  background-color: var(--color-1)
}

.fast-option-selected {
  background-color: var(--color-3);
}

.custom-select-height .ReactVirtualized__List{
  height: 200px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/CommonComp/customSelect.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgIG;;AAEH;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* @charset \"UTF-8\";\n.selectNative,\n.selectCustom {\n  position: relative;\n  width: 22rem;\n  height: 4rem;\n}\n\n.selectCustom {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: none;\n}\n\n@media (hover: hover) {\n  .selectCustom {\n    display: block;\n  }\n\n  .selectNative:focus + .selectCustom {\n    display: none;\n  }\n}\n\n.selectNative:focus,\n.selectCustom.isActive .selectCustom-trigger {\n  outline: none;\n  box-shadow: white 0 0 0 0.2rem, #ff821f 0 0 0 0.4rem;\n}\n\n.select {\n  position: relative;\n}\n\n.selectLabel {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 0.4rem;\n}\n\n.selectWrapper {\n  position: relative;\n}\n\n.selectNative,\n.selectCustom-trigger {\n  font-size: 1.6rem;\n  background-color: #fff;\n  border: 1px solid #6f6f6f;\n  border-radius: 0.4rem;\n}\n\n.selectNative {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\");\n  background-repeat: no-repeat;\n  background-position-x: 100%;\n  background-position-y: 0.8rem;\n  padding: 0rem 0.8rem;\n}\n\n.selectCustom-trigger {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background-color: #fff;\n  padding: 0.8rem 0.8rem;\n  cursor: pointer;\n}\n\n.selectCustom-trigger::after {\n  content: \"▾\";\n  position: absolute;\n  top: 0;\n  line-height: 3.8rem;\n  right: 0.8rem;\n}\n\n.selectCustom-trigger:hover {\n  border-color: #8c00ff;\n}\n\n.selectCustom-options {\n  position: absolute;\n  top: calc(3.8rem + 0.8rem);\n  left: 0;\n  width: 100%;\n  border: 1px solid #6f6f6f;\n  border-radius: 0.4rem;\n  background-color: #fff;\n  box-shadow: 0 0 4px #e9e1f8;\n  z-index: 1;\n  padding: 0.8rem 0;\n  display: none;\n}\n\n.selectCustom.isActive .selectCustom-options {\n  display: block;\n}\n\n.selectCustom-option {\n  position: relative;\n  padding: 0.8rem;\n  padding-left: 2.5rem;\n}\n\n.selectCustom-option.isHover,\n.selectCustom-option:hover {\n  background-color: #865bd7;\n  color: white;\n  cursor: default;\n}\n\n.selectCustom-option:not(:last-of-type)::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  border-bottom: 1px solid #d3d3d3;\n}\n\n.selectCustom-option.isActive::before {\n  content: \"✓\";\n  position: absolute;\n  left: 0.8rem;\n} */\n\n[class*=\"-indicatorContainer\"]{\n  padding: 5px !important;\n}\n\n.fast-option {\n  font-size: 12px;\n}\n\n.fast-option-focused{\n  background-color: var(--color-1)\n}\n\n.fast-option-selected {\n  background-color: var(--color-3);\n}\n\n.custom-select-height .ReactVirtualized__List{\n  height: 200px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
